import { Text, View } from '@react-pdf/renderer';

import { usePDFContext } from '../../PDFProvider';
import { styles } from './styles';

export function Specs() {
  const { specs } = usePDFContext();

  if (!specs) {
    return null;
  }

  return (
    <View style={styles.row}>
      <View style={styles.fullRow}>
        <Text style={[styles.bold, { paddingBottom: '4px' }]}>Notes</Text>
        <Text>{specs}</Text>
      </View>
    </View>
  );
}
